enum StarbucksCouponType {
  VillaAirportEmployee = 'villa-airport-employee-discount-15%',
}

export { StarbucksCouponType };
